import ListTransporters from "../../../components/@logistics/ListTransporters";

import { routeTypes } from "../../../hooks/useSystemRoutes";

export default function TransportersPage() {

    return (
        <ListTransporters 
            routeType={routeTypes.admin}
        />
    )
}       